import type {CampaignDiscountModalState, CampaignDiscountOption} from '../../types';

import {Button} from '@ds/components';
import {cn} from '@ds/helpers';
import logoTypeSvg from 'assets/images/promotion-center/new/logoType.svg';

type CampaignProductDiscountProps = {
  discountModal: CampaignDiscountModalState;
  setDiscountModal: React.Dispatch<React.SetStateAction<CampaignDiscountModalState>>;
  setProductDiscount: () => void;
};

const DISCOUNT_TYPE_LABELS: Record<string, string> = {
  tn: 'تخفیف نارنجی',
  bundle: 'پک بصرفه'
};

const CampaignProductDiscount: React.FC<CampaignProductDiscountProps> = ({
  discountModal,
  setDiscountModal,
  setProductDiscount
}) => {
  const item = discountModal.data;
  if (!item) {
    return null;
  }

  const selectDiscount = (selected: CampaignDiscountOption) => {
    setDiscountModal((current) => {
      if (!current.data) {
        return current;
      }
      return {
        ...current,
        data: {
          ...current.data,
          suggested_option: current.data.suggested_option?.map((option) => ({
            ...option,
            data: {
              ...option.data,
              selected: option.data.percentage === selected.data.percentage
            }
          }))
        }
      };
    });
  };

  return (
    <div className="flex flex-col p-4">
      <div className="flex h-50 items-center justify-center">
        <img
          className="h-45 object-contain"
          src={item.image_url ? item.image_url : logoTypeSvg}
          alt={item.title}
        />
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-1.5 border-b border-gray-03 p-1">
          <span className="text-body-sm text-gray-05">نام محصول</span>
          <span className="text-body-sm text-neutral-fg">{item.title}</span>
        </div>
        <div className="flex flex-col gap-1.5 border-b border-gray-03 p-1">
          <span className="text-body-sm text-gray-05">نوع تخفیف</span>
          <span className="text-body-sm text-neutral-fg">
            {item.type ? DISCOUNT_TYPE_LABELS[item.type] : null}
          </span>
        </div>
        <div className="mt-2.5 flex flex-col">
          <span className="text-subtitle-md text-neutral-fg">سهم شما</span>
          <div className="mt-5 flex justify-center gap-2">
            {item.suggested_option?.map((option) => (
              <button
                type="button"
                key={option.data.percentage}
                className={cn(
                  'flex h-13.5 flex-1 flex-col items-center justify-center rounded border border-gray-03',
                  option.data.selected && 'border-orange bg-orange-wash'
                )}
                onClick={() => selectDiscount(option)}
              >
                <span className="text-body-sm">{option.data.percentage} %</span>
                <span className="text-body-xs">{option.data.price} تومان</span>
              </button>
            ))}
          </div>
        </div>
        <div className="mt-7.5">
          <Button fullWidth onClick={setProductDiscount}>
            تایید
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CampaignProductDiscount;
